import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  NgZone,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { BehaviorSubject, lastValueFrom, Subscription } from 'rxjs';
import { CommonService } from '../../services/common/common.service';
import { CompanyService } from '../../services/company/company.service';
import { ToastService } from '../../services/toast.service';
import moment from 'moment';
import Swal from 'sweetalert2';
import { TranslateService } from '@ngx-translate/core';
import { EmployeeListService } from '../../services/employee/employee-list.service';
import { Location } from '@angular/common';
import { LanguageService } from '../../services/language.service';
import { io, Socket } from 'socket.io-client';
import { EnvironmentService } from '../../services/environment.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangePasswordComponent } from '../components/change-password/change-password.component';
import { BulkUploadSocketService } from '../../services/upload/bulk-upload-socket.service';
import { NotificationsService } from '../../services/notfication/notifications.service';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit {
  @ViewChild('fullscreenContainer') fullscreenContainer!: ElementRef;
  @ViewChild('companySelect') companySelect!: NgSelectComponent;
  @ViewChild('notificationWrapper') notificationWrapper!: ElementRef;

  isDropdownOpen = false;
  loggedUser: any = {};
  companyName: any = '';
  languageDropdown: boolean = false;
  theme: boolean = false;
  selectedCompanyId: any | null = null;

  companyList!: any[];
  displayContent: boolean = false;
  @Input() datas!: any[];
  userProfile: any;
  fullscreenWindow: boolean = false;
  language: string = '';
  // private socket: Socket;
  showMessages: boolean = false;
  isPanelOpen = false;
  notifications: any[] = [];
  dateFormat: any = 'dd/MM/yyyy';
  date: any = 'dd-mm-yy'
  angularDateFormat: any;
  private sub?: Subscription;
  // @Output() selectedData: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private readonly router: Router,
    private readonly auth: AuthService,
    private readonly commonService: CommonService,
    private readonly companyService: CompanyService,
    private readonly toastService: ToastService,
    private empListService: EmployeeListService,
    private readonly translate: TranslateService,
    private readonly location: Location,
    private languageService: LanguageService,
    private readonly env: EnvironmentService,
    private readonly modalService: NgbModal,
    private readonly bulkSocket: BulkUploadSocketService,
    private readonly notify: NotificationsService,
    private readonly ngZone: NgZone
  ) {
    const authUser = localStorage.getItem(this.auth.AUTH_USER);
    const parsedUser = authUser ? JSON.parse(authUser) : null;
    this.loggedUser = parsedUser;

    // this.socket = io(this.env.bulkUploadSocketUrl);

    // this.socket.on('connect', () => {
    // console.log('Connected to server');
    // });

    // this.socket.on('messageToClient', (msg: any) => {
    //console.log('Received message from server:', msg);
    // this.notifications.push(msg);
    //   this.showMessages = true;
    // });

    this.sub = this.bulkSocket.getMessages().subscribe((msg) => {
      const data = msg?.data ?? {};
      const successCount = data.successCount ?? 0;
      const failureCount = data.failureCount ?? 0;

      this.ngZone.run(() => {
        // Refresh notification list and open the panel immediately
        this.getNotification();
        this.notify.triggerNotificationUpdate();
        // this.isPanelOpen = true;
        console.log("=-header-=msg", msg);
        if (msg?.moduleType != 'PAYROLL' && !msg?.data?.message?.startsWith('Payroll')) {
          if (data.nodata) {
            this.toastService.info('No data found in uploaded file');
          } else if (successCount > 0 && failureCount <= 0) {
            this.toastService.success('Data uploaded successfully');
          } else if (successCount <= 0 && failureCount > 0) {
            this.toastService.failure('Data upload failed. Check notifications for the error report.');
          } else if (successCount > 0 && failureCount > 0) {
            this.toastService.failure(`Upload complete: ${successCount} succeeded, ${failureCount} failed. Check notifications for error report.`);
          }
        }
        if (successCount > 0) {
          setTimeout(() => {
            window.location.reload();
          }, 4000);
        }
      });
    });
  }
  get dropdownClass() {
    return this.isDropdownOpen
      ? 'dropdown-menu dropdown-menu-right dropdown-menu-arrow show'
      : 'dropdown-menu dropdown-menu-right dropdown-menu-arrow';
  }

  userData: any = localStorage.getItem('auth_user');
  employeeName: any = this.userData ? JSON.parse(this.userData) : '';
  userLogo: string = this.employeeName.icon;
  userID: any;
  userRole: any;

  ngOnInit(): void {
    // console.log('employeeName', this.employeeName);
    let data: any = this.commonService.getLocalStorageData();
    if (data) {
      this.userID = data?.userID;
      this.bulkSocket.joinRoom(this.userID);
      this.userRole = data?.role_type;
      if (!data.client) {
        this.getDateFormat(data.companyID);
      }
    }

    let languageChoose = localStorage.getItem('lang');
    if (languageChoose) {
      // this.languageService.setLanguage(language)
      this.language = languageChoose;
    }
    if (this.employeeName.role == 3 || this.employeeName.role == 4) {
      this.selectedCompanyId = this.employeeName.companyID;
    }
    // if (this.loggedUser && this.loggedUser?.userID) {
    //   this.empListService.getEmployeeView(this.loggedUser?.userID).subscribe({
    //     next: (resp) => {
    //       // this.userProfile = resp?.datas?.photo;
    //       // this.loadImage(resp?.datas?.photo);
    //     },
    //   });
    // }

    document.addEventListener('fullscreenchange', () => {
      this.fullscreenWindow = !!document.fullscreenElement;
    });

    this.getCompanyList();
    this.getCompanybyID();
    this.getNotification();

    // Listen for notification updates from other components
    this.notify.notificationUpdated$.subscribe(() => {
      this.getNotification();
    });

    // this.startMediaAccess();
  }

  getDateFormat(companyId: any) {
    this.companyService.getParametersById(companyId).subscribe({
      next: (resp) => {
        if (resp?.data?.date_format) {
          this.dateFormat = resp?.data?.date_format.replace('mm', 'MM');
          this.date = resp?.data?.date_format;
          this.angularDateFormat = this.commonService.convertPrimeNGToAngularFormat(this.date);
        }
      },
    });
  }

  // startMediaAccess() {
  //   navigator.mediaDevices.getUserMedia({ video: true, audio: true })
  //     .then(stream => {
  //       this.videoRef.nativeElement.srcObject = stream;
  //     })
  //     .catch(err => {
  //       console.error('Media access denied:', err);
  //       alert('Please allow camera and microphone access.');
  //     });
  // }

  toggleFullscreen() {
    const elem = document.documentElement;
    if (!document.fullscreenElement) {
      this.fullscreenWindow = true;
      elem
        .requestFullscreen()
        .then(() => (this.fullscreenWindow = true))
        .catch((err) => {
          console.error('Error entering fullscreen:', err);
        });
    } else {
      this.fullscreenWindow = false;
      document
        .exitFullscreen()
        .then(() => (this.fullscreenWindow = false))
        .catch((err) => {
          console.error('Error exiting fullscreen:', err);
        });
    }
  }

  @HostListener('document:fullscreenchange', [])
  onFullscreenChange() {
    this.fullscreenWindow = !!document.fullscreenElement;
  }

  toggleDropdown() {
    this.isDropdownOpen = !this.isDropdownOpen;
    this.isPanelOpen = false;
  }

  toggleLanguage() {
    this.languageDropdown = !this.languageDropdown;
  }

  logout() {
    this.auth.logout().subscribe({
      next: (resp) => {
        resp.message;
      },
    });
    localStorage.removeItem('auth_user');
    localStorage.removeItem('menus');
    localStorage.removeItem('default_company');
    localStorage.removeItem('selectedMenuID');
    this.auth.loggedIn.next(false);
    this.router.navigate(['/']);
  }

  selectItem(data: any) {
    Swal.fire({
      title: 'Are you sure you want to change company?',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, change it!',
      cancelButtonText: 'Cancel',
    }).then(async (result) => {
      if (result.isConfirmed) {
        let localStorageData = this.loggedUser;
        localStorageData.companyID = data.id;
        let newToken = await lastValueFrom(
          this.commonService.generateToken({
            token: this.employeeName.accessToken,
            company_id: data.id,
          })
        );
        localStorageData.accessToken = newToken;

        this.auth.updateUser(localStorageData);
        localStorage.setItem('default_company', data.id);
        const targetRoute =
          this.employeeName.role == 2
            ? 'app/company/company-list'
            : 'app/employee/employee-dashboard';

        this.router.navigate([targetRoute]).then(() => {
          window.location.reload();
        });
      }
    });
    // this.toastService.info('Please confirm to change the company');
  }

  enableContent() {
    this.displayContent = !this.displayContent;
  }

  objectEntries(obj: any) {
    return Object.entries(obj);
  }

  logoReloadAttempts = 0;
  maxLogoReloadAttempts = 2;

  selectedCompany: any = '';
  async getCompanyList() {
    const response = await lastValueFrom(
      this.companyService.empCompanyManageList()
    );
    let data = response?.data ?? [];
    this.datas = data;
    let default_company = localStorage.getItem('default_company');
    if (default_company) {
      this.selectedCompanyId = Number(default_company);
    }
    if (this.employeeName.role == 2 && data.length > 0 && !default_company) {
      this.selectedCompanyId = data[0]?.id;
    }
  }

  async getCompanybyID() {
    const response = await lastValueFrom(
      this.companyService.getCompanybyID(this.loggedUser.companyID)
    );
    this.companyName = response?.data?.company_name || '';
    if (this.userRole == 'sub_admin' || this.userRole == 'admin') {
      if (response?.data?.logo) {
        this.loadImage(response?.data?.logo)
      }
    } else if (this.userRole !== 'sub_admin' && this.userRole !== 'admin' && this.userRole !== 'super_admin') {
      this.empListService.getnewEmployee(this.userID).subscribe({
        next: (resp) => {
          if (resp?.data?.employee?.photo) {
            this.loadImage(resp?.data?.employee?.photo)
          }
        }
      })
    }
  }

  reloadLogo() {
    // Prevent infinite loop - only retry up to maxLogoReloadAttempts times
    if (this.logoReloadAttempts >= this.maxLogoReloadAttempts) {
      console.warn('Max logo reload attempts reached');
      return;
    }

    this.logoReloadAttempts++;
    // Reload the image from the original encrypted file path
    const originalPath = this.employeeName.icon;
    if (originalPath) {
      this.loadImage(originalPath);
    }
  }

  switchLanguage(language: string) {
    // this.translate.use(language);
    this.languageService.setLanguage(language);
  }

  changeLanguage(event: any) {
    this.languageService.setLanguage(event.target.value);
  }

  changeColor(event: Event) {
    // this.document.body.classList.toggle('dark');
  }

  goback() {
    this.location.back();
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    if (this.isPanelOpen && this.notificationWrapper) {
      const clickedInsideWrapper = this.notificationWrapper.nativeElement.contains(event.target);
      if (!clickedInsideWrapper) {
        this.closePanel();
      }
    }
  }

  toggleNotification() {
    this.togglePanel();
    this.isDropdownOpen = false;
  }

  togglePanel() {
    this.isPanelOpen = !this.isPanelOpen;
  }

  closePanel() {
    this.isPanelOpen = false;
  }

  onChangePasswordClick() {
    this.openPopup();
  }

  openPopup() {
    const modalRef = this.modalService.open(ChangePasswordComponent, {
      size: 'md',
      backdrop: 'static', // disables click outside to close
      keyboard: false,
    });
  }

  getNotification() {
    this.notify.notificationGetByUserID().subscribe({
      next: (resp) => {
        this.notifications = resp?.data?.data?.rows;
        this.notifications = resp?.data?.data?.rows.map((msg: any) => ({
          ...msg,
          ...this.parseMessage(msg.message)
        }))
        if (this.notifications.length > 0) {
          this.showMessages = true;
        } else {
          this.showMessages = false;
          this.closePanel();
        }
      },
      error: (err) => {
        console.error(err);
      },
    });
  }

  parseMessage(message: string) {
    const match = message.match(/(\d+\sprocessed),\s*(\d+\sfailed)/i);
    return {
      processedPart: match ? match[1] : '',
      failedPart: match ? match[2] : ''
    };
  }

  get unreadCount(): number {
    return this.notifications?.filter(n => !n.isRead).length || 0;
  }

  markasRead(msg: any, type: 'id' | 'url') {
    if (type === 'id') {
      this.notify.markasRead(msg._id).subscribe({
        next: () => {
          this.getNotification();
          // Trigger notification-report to refresh
          this.notify.triggerNotificationUpdate();
        },
        error: (err) => console.error(err),
      });
      return;
    }

    const { moduleType, actionUrl, reportUrl } = msg;

    if (moduleType === 'Bulk Upload') {
      this.downloadNotificationFile(actionUrl);

    } else if (moduleType === 'PAYROLL') {
      // ✅ 1. Download FIRST (direct browser download)
      this.downloadNotificationFile(reportUrl);

      // ✅ 2. Redirect AFTER delay
      if (actionUrl) {
        setTimeout(() => {
          this.router.navigateByUrl(actionUrl);
        }, 1200); // increase delay for reliability
      }

      this.closePanel();
    } else {
      this.router.navigateByUrl(actionUrl);
      this.closePanel();
    }
  }

  downloadNotificationFile(fileUrl: string) {
    if (!fileUrl) return;

    const rawName = fileUrl.split('/').pop()?.split('?')[0] || 'download';
    const filename = decodeURIComponent(rawName).replace(/^\d+_/, '');

    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = filename;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  markasReadAll() {
    this.notify.markasReadAll(this.userID).subscribe({
      next: resp => {
        this.getNotification();
        // Trigger notification-report to refresh
        this.notify.triggerNotificationUpdate();
      }
    })
  }

  clearAll() {
    this.notify.clearAll(this.userID).subscribe({
      next: resp => {
        console.log('resp', resp);
        this.getNotification();
        // Trigger notification-report to refresh
        this.notify.triggerNotificationUpdate();
      }
    })
  }

  loadImage(key: string) {
    if (!key) return;

    // Reset reload attempts when loading a new image
    this.logoReloadAttempts = 0;

    const encodedKey = encodeURIComponent(key);
    const url = `${encodedKey}?cacheBust=${new Date().getTime()}`;

    this.commonService.getFile(encodedKey).subscribe({
      next: (blob) => {
        this.userLogo = URL.createObjectURL(blob);
        this.userProfile = URL.createObjectURL(blob);
      },
      error: (err) => {
        console.error('Error loading image:', err);
        // Use the URL directly as fallback
        this.userProfile = URL.createObjectURL(new Blob());
      }
    });
  }

  copyCompanyName(event: MouseEvent) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (this.companySelect) {
      this.companySelect.close();
    }
    const selectedCompany = this.datas.find((d) => d.id === this.selectedCompanyId);
    if (selectedCompany) {
      navigator.clipboard.writeText(selectedCompany.company_name);
      this.toastService.success('Company name copied to clipboard');
    }
  }
}